module.exports = __webpack_public_path__ + "static/img/img_index_slide_news.64e0225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data/img_index_slide_news.jpg
// module id = FDua
// module chunks = 2